<template>
            <v-card hover :to="url"  height='220px' class='white--text' color="secondary" >
              
              <v-card-title primary-title>
                
                <div>
                  <div class="headline">                    
                    <v-icon
                    dark
                    large
                    left>
                    {{icon}}
                </v-icon>
                    {{title}}</div>
                  <span>Total Assets :</span>
                  <span class="display-1">{{data}}</span>
                  <br>
                  <span>Ready :</span>
                  <span class="display-1">{{readyData}}</span><br>
                  <span>Recycled :</span>
                  <span class="display-1">{{recycleData}}</span>
                </div>
              </v-card-title>
             
            </v-card>
</template>

<script>
export default {
    props : {
        icon : String,
        title : String,
        data : Number,
        readyData : Number,
        recycleData : Number,
        url : String
    }   
}
</script>
